var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToneOfVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1502_42612",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1502_42612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 13.3334V12.1667C2.11324 12.1667 2.5556 12.1375 2.9931 12.0792C3.4306 12.0209 3.85838 11.9139 4.27643 11.7584C3.82921 11.5348 3.47678 11.2115 3.21914 10.7886C2.9615 10.3657 2.83268 9.9063 2.83268 9.41047V8.08338H5.16602V6.33338H7.13477L5.22435 2.51255L6.27435 1.98755L8.18477 5.80838C8.37921 6.19727 8.36463 6.57644 8.14102 6.94588C7.91741 7.31533 7.58685 7.50005 7.14935 7.50005H6.33268V8.08338C6.33268 8.40422 6.21845 8.67887 5.98997 8.90734C5.7615 9.13581 5.48685 9.25005 5.16602 9.25005H3.99935V9.41047C3.99935 9.75074 4.10386 10.0497 4.31289 10.3073C4.52192 10.565 4.78685 10.7375 5.10768 10.825L5.28268 10.8688C5.67157 10.966 5.89032 11.2091 5.93893 11.598C5.98754 11.9869 5.83685 12.2785 5.48685 12.473C4.90352 12.7938 4.28859 13.0174 3.64206 13.1438C2.99553 13.2702 2.33685 13.3334 1.66602 13.3334ZM10.0077 11.6709L9.17643 10.8542C9.3806 10.65 9.54102 10.4143 9.65768 10.1469C9.77435 9.87956 9.83268 9.59033 9.83268 9.27922C9.83268 8.9681 9.77435 8.67887 9.65768 8.41151C9.54102 8.14415 9.3806 7.90838 9.17643 7.70422L10.0077 6.87297C10.3188 7.18408 10.5618 7.54623 10.7368 7.95942C10.9118 8.37262 10.9993 8.81255 10.9993 9.27922C10.9993 9.74588 10.9118 10.1834 10.7368 10.5917C10.5618 11 10.3188 11.3598 10.0077 11.6709ZM11.6556 13.3334L10.8243 12.5021C11.2424 12.0841 11.5705 11.6004 11.8087 11.0511C12.0469 10.5018 12.166 9.91116 12.166 9.27922C12.166 8.63755 12.0469 8.04449 11.8087 7.50005C11.5705 6.9556 11.2424 6.47435 10.8243 6.0563L11.6556 5.22505C12.1806 5.75005 12.5914 6.35769 12.8879 7.04797C13.1844 7.73824 13.3327 8.48199 13.3327 9.27922C13.3327 10.0667 13.1844 10.808 12.8879 11.5032C12.5914 12.1983 12.1806 12.8084 11.6556 13.3334Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToneOfVoice);
export default __webpack_public_path__ + "static/media/icon_tone_of_voice.d6e51455559900cfd6e5c2c31f451534.svg";
export { ForwardRef as ReactComponent };